export default __webpack_public_path__ + "static/media/cooperando.a9b54ee0.png";